"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _SubtleButton = _interopRequireDefault(require("../SubtleButton"));

var _MoreVert = _interopRequireDefault(require("@insided/shared/icons/MoreVert"));

require("./styles.scss");

var _classnames = _interopRequireDefault(require("classnames"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MultiDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MultiDropdown, _Component);

  var _super = _createSuper(MultiDropdown);

  function MultiDropdown() {
    (0, _classCallCheck2.default)(this, MultiDropdown);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(MultiDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actionsToDisplay = _this$props.actionsToDisplay,
          _this$props$menuOptio = _this$props.menuOptions,
          menuOptions = _this$props$menuOptio === void 0 ? [] : _this$props$menuOptio,
          _this$props$isHovered = _this$props.isHovered,
          isHovered = _this$props$isHovered === void 0 ? false : _this$props$isHovered,
          _this$props$useContro = _this$props.useControlTheme,
          useControlTheme = _this$props$useContro === void 0 ? false : _this$props$useContro;
      var hasActions = isHovered && actionsToDisplay && actionsToDisplay.length > 0; // Check if menuOptions is a 2D array

      var is2DArray = menuOptions.length > 0 && Array.isArray(menuOptions[0]);
      return (0, _preact.h)("div", {
        className: "multi-dropdown",
        role: "group",
        "aria-label": "Topic actions"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('multi-dropdown__container', {
          'has-actions': hasActions && actionsToDisplay && actionsToDisplay.length > 0
        })
      }, hasActions && actionsToDisplay.map(function (action, index) {
        return (0, _preact.h)("div", {
          key: index,
          className: "multi-dropdown__action-button"
        }, action);
      }), (0, _preact.h)("div", {
        className: (0, _classnames.default)('actions-menu', 'text--meta', 'post__actions', 'qa-post-actions')
      }, (0, _preact.h)(_dropdown.default, {
        size: "S",
        align: "right",
        popupName: "multi-dropdown-actions",
        closeOnDropdownClick: true,
        isControl: useControlTheme,
        className: "actions-menu-dropdown multi-dropdown__dropdown",
        trigger: function trigger(isTriggerOpen) {
          return (0, _preact.h)(_phrase.default, {
            p: "accessibility_label.show_additional_post_actions",
            renderAsText: true
          }, function (accessibilityLabel) {
            return (0, _preact.h)(_SubtleButton.default, {
              size: "medium",
              className: "tooltip-trigger js-tooltip-trigger",
              icon: (0, _preact.h)(_MoreVert.default, {
                width: 16,
                height: 16
              }),
              "aria-label": accessibilityLabel,
              isSelected: isTriggerOpen
            });
          });
        }
      }, is2DArray ? function () {
        var nonEmptyGroups = menuOptions.filter(function (subArray) {
          return subArray.length > 0;
        });
        return nonEmptyGroups.map(function (subArray, groupIndex) {
          return subArray.map(function (item) {
            var _item$children;

            return (0, _preact.h)(_dropdown.DropdownItem, {
              key: item.title,
              type: item.type,
              onClick: item.onClick,
              href: (0, _absoluteUrlRuntime.resolveUrl)(item.href)
            }, (_item$children = item.children) !== null && _item$children !== void 0 ? _item$children : (0, _preact.h)(_phrase.default, {
              p: item.title
            }));
          }).concat(groupIndex < nonEmptyGroups.length - 1 ? [(0, _preact.h)(_dropdown.DropdownDivider, {
            key: "divider-".concat(groupIndex)
          })] : []);
        });
      }() : menuOptions.map(function (item) {
        var _item$children2;

        return (0, _preact.h)(_dropdown.DropdownItem, {
          key: item.title,
          type: item.type,
          onClick: item.onClick,
          href: (0, _absoluteUrlRuntime.resolveUrl)(item.href)
        }, (_item$children2 = item.children) !== null && _item$children2 !== void 0 ? _item$children2 : (0, _preact.h)(_phrase.default, {
          p: item.title
        }));
      })))));
    }
  }]);
  return MultiDropdown;
}(_preact.Component);

var _default = MultiDropdown;
exports.default = _default;